import { getClient } from '@/lib/restClient';
import { StoreManagementUberStoreService } from '@/services/StoreManagement/UberStores/StoreManagementUberStoreService';

export type UberStoreListResponse = {
  id: string;
  name: string;
  master_store: IntegratedMasterStore | null;
  auth_store: IntegratedAuthStore | null;
  linked_status: string | null;
  is_order_manager: boolean | null;
};

export type IntegratedMasterStore = {
  name: string;
};

export type IntegratedAuthStore = {
  name: string;
};

export const useStoreManagementUberStoreList = async (
  code: string
): Promise<UberStoreListResponse[]> => {
  const storeManagementUberStoreService = new StoreManagementUberStoreService(
    getClient()
  );
  return storeManagementUberStoreService.list(code);
};
